exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.test_page_wrap{height:100%\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/studyCenter/switch/examination/examinationPage.vue"],"names":[],"mappings":";AAqBA,gBACE,WAAY;CACb","file":"examinationPage.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.test_page_wrap{\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98eccdae","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/studyCenter/switch/examination/examinationPage.vue
// module id = Fup5
// module chunks = 96